
import { useState, useEffect } from 'react';
import { GroupTagPicker } from './GroupTagPicker';
import { useQuery, gql } from '@apollo/client';

interface IProps {
    setId: any,
    showErrors: boolean,
    setTagIds: any,
}

const GET_ORGANISATION_PERSON_ID_FORMULA = gql`
query Organisation {
    me {
        organisation {
            personIdentifierFormula
        }
    }
}`;

const KEY_LOOKUP = gql`
query KeyCounterLookup($groupId: Int!) {
    keyCounterLookup(groupId: $groupId) {
        next
        key
    }
}`;

const PersonIdPicker = ({
    setId,
    showErrors,
    setTagIds,
}: IProps) => {
    // TODO: get this from the organisation settings
    // TODO: look up the key counts for the increments

    const [formula, setFormula] = useState('');
    const { loading, data } = useQuery(GET_ORGANISATION_PERSON_ID_FORMULA);
    const { loading: keyLookupLoading, data: keyLookupData, refetch } = useQuery(KEY_LOOKUP, {
        variables: { groupId: 0 }
    });

    const [skuParts, setSkuParts] = useState<Array<{ groupId: number, value: string }>>([]);

    useEffect(() => {
        if (data) {
            const formula = data.me.organisation.personIdentifierFormula;
            setFormula(formula);
            const parts = formula.split('+');
            // format {key:2} , extract id
            const keys = parts.filter((p: string) => p.includes('key')).map((part: any) => {
                return part.split(':')[1].replace('}', '');
            });

            refetch({ groupId: parseInt(keys[0], 10) })

            const newSkuParts = parts.filter((p: string) => !p.includes('key')).map((part: any) => {
                return {
                    groupId: parseInt(part, 10),
                    value: ''
                }
            });
            setSkuParts(newSkuParts);
            setId(newSkuParts.map((skuPart: any) => skuPart.value).join(''));
        }
    }, [data]);

    if (loading || keyLookupLoading) return <p>Loading...</p>;

    return (
        <>
            {skuParts.map(({groupId}) => (
                <GroupTagPicker
                    key={groupId}
                    showErrors={showErrors}
                    groupId={groupId}
                    setValue={(s:string, groupId: number, tagId: number) => {
                        // TODO: This only deals with adding the community so expand that if required
                        setTagIds([tagId]);
                        const newSkuParts = skuParts.map((skuPart) => {
                            if (skuPart.groupId === groupId) {
                                return {
                                    ...skuPart,
                                    value: s
                                }
                            }
                            return skuPart;
                        });

                        if (formula !== '') {
                            setId(formula.split('+').map((part: string) => {
                                if (part.includes('key')) {
                                    const key = part.split(':')[1].replace('}', '');

                                    const entry = keyLookupData.keyCounterLookup.find((k: any) => k.key === s)
                                    if (entry != null) {
                                        return entry.next;
                                    } else {
                                        return 1
                                    }
                                } else {
                                    const skuPart = newSkuParts.find((skuPart) => skuPart.groupId === parseInt(part, 10));
                                    if (skuPart == null) {
                                        return '';
                                    }
                                    return skuPart.value;
                                }
                            }).join(''))
                        }

                        setSkuParts(newSkuParts);
                    }}
                />
            ))}
            <br/>
        </>
    );
}

export { PersonIdPicker }
